import React from 'react'
import { NavLink } from 'react-router-dom'
import { button_action_on, button_action_off, getOrderButtonLabel } from '../../utils/gpa-utils'

const GpaOrderButton = ({ order, userId, actionRequired, baseUrl, content }) => (
  <NavLink exact={true} to={`${baseUrl}/${order.idSolicitud}`} className={actionRequired ? button_action_on : button_action_off}>{getOrderButtonLabel(order, userId, content)}</NavLink>
)

export default GpaOrderButton